<template>
    <b-alert :variant="variant" :show="$page.props.flash.success || $page.props.flash.error" v-if="$page.props.flash">
        {{ $page.props.flash.success || $page.props.flash.error }}
    </b-alert>
</template>

<script>
export default {
  data () {
    return {
      variant: 'info'
    }
  },
  watch: {
    '$page.props.flash': {
      handler: function (val, oldVal) {
        if (!val) {
          return
        }

        if (val.success) {
          this.variant = 'success'
        } else if (val.error) {
          this.variant = 'danger'
        } else {
          this.variant = 'info'
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
